
<div class="campaign-thankyou-wrapper">
  <div class="back-btn-wrapper">
    <button class="btn" mat-icon-button (click)="goToFundraiser()">
      <mat-icon>chevron_left</mat-icon>
    </button>
  </div>
  <div class="fundraiser-live-wrapper">
    <div class="live-content-wrapper">
      <div class="fundraiser-image-box">
        <div class="image-wrapper">
          <img src="/assets/images/ketto-premium-services/ketto-support-icon.png" alt="ketto support icon" />
        </div>
      </div>
      <div class="content">
        <div class="title">
          {{info?.congratsContent?.title}}
        </div>
        <div class="desc">
          {{info?.congratsContent?.desc}}
        </div>
      </div>
      <div *ngIf="isMobile"></div>
      <ng-container [ngTemplateOutlet]="shareBtnWrapper" *ngIf="isMobile"></ng-container>
    </div>
    <div class="share-whatsapp-wrapper" *ngIf="!isMobile">
      <ng-container [ngTemplateOutlet]="shareBtnWrapper"></ng-container>
    </div>
  </div>
  <div class="plan-wrapper">
    <div class="top-header">
      <div class="title">
        {{info?.planDetails?.header?.title}}
      </div>
      <div class="desc">
        {{info.planDetails?.header.desc}}
      </div>
    </div>
    <div class="plan-detail-wrapper">
      <app-premium-services [list]="list" [campaignId]="campaignId" [type]="type" [fundraiser]="fundraiser"/>
    </div>
  </div>
  <div class="notes-wrapper">
    <div class="head">
      Notes:-
    </div>
    <ul class="list">
      <li *ngFor="let listItem of info?.list">{{listItem}}</li>
    </ul>
  </div>
</div>


<ng-template #shareBtnWrapper>
  <div class="whatsapp-share-wrapper">
    <div class="share-btn-wrapper">
      <button mat-button class="share-btn" (click)="getWhatsAppMessage()"> 
        <mat-icon class="icon-whatsapp" [style.color]="white"></mat-icon>
        <span class="label">{{info?.whatsappShareContent?.shareTitle}}</span>
      </button>
    </div>
    <div class="desc">
      {{info?.whatsappShareContent?.desc}}
    </div>
  </div>
</ng-template>